<template>
  <div
    :class="[`${$options.name}`, active ? `${$options.name}--active` : '']"
    class="tw:p-2 tw:gap-2 tw:flex tw:justify-start tw:items-center tw:caption tw:text-default-500 tw:w-full tw:h-14 tw:min-h-14 tw:overflow-hidden tw:cursor-pointer"
    @click="handleClick"
  >
    <div class="tw:flex tw:justify-center tw:items-center">
      <img
        :alt="trans._menu.header.workspace.avatar"
        :src="brandingLogo || 'https://d3vhsxl1pwzf0p.cloudfront.net/avatar/store.svg'"
        class="tw:border tw:border-default-200 tw:rounded-full tw:w-10 tw:h-10 tw:object-contain tw:bg-white"
      />
    </div>
    <div class="tw:flex tw:gap-1 tw:flex-col tw:flex-1 tw:w-0">
      <p class="tw:body-2 tw:truncate">{{ companyUrl }}</p>
      <p class="tw:caption tw:!text-default-700 tw:truncate">
        {{ trans._menu.header.workspace.workspaceId }}: {{ trackerId }}
      </p>
    </div>
    <div class="tw:flex tw:justify-center tw:items-center tw:!text-default-700 tw:text-xs">
      <font-awesome-icon icon="fa-light fa-angles-up-down" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { gtagUniversalSend } from "vue-app/plugins/edroneGtag";

export default defineComponent({
  name: "MainMenuWorkspaceButton",
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
  setup(props, { emit }) {
    const trackerId = window.EDRONE_CONTEXT.trackerId;
    const companyUrl = window.EDRONE_CONTEXT.user.companyUrl;
    const brandingLogo = window.EDRONE_CONTEXT.tracker?.trackerBranding?.logoUrl;

    function handleClick() {
      gtagUniversalSend({ component_id: "main-menu__workspace-button" });
      emit("click");
    }

    return {
      trackerId,
      companyUrl,
      brandingLogo,
      handleClick,
    };
  },
});
</script>

<style scoped>
@reference "vue-app/assets/scss/main.css";

.MainMenuWorkspaceButton--active {
  @apply tw:bg-default-100;
}

.MainMenuWorkspaceButton:hover:not(.MainMenuWorkspaceButton--active) {
  @apply tw:bg-default-000;
}
</style>
